// This file is part of re-motion
// Copyright (c) rubicon IT GmbH, www.rubicon.eu
// 
import { ILocalRpcHub } from "@lib/messaging/rpc/ILocalRpcHub";
import { IRpcContext } from "@lib/messaging/rpc/IRpcContext";
import { Assert } from "@lib/utilities/Assert";

/**
 * Provides helper methods for the RPC infrastructure.
 */
export class RpcUtility
{
  static registerContract(contract: { [key: string]: AnyFunction }, localRpcHub: ILocalRpcHub<IRpcContext>)
  {
    for (const key in contract)
    {
      if (!contract.hasOwnProperty(key))
        continue;

      const value = contract[key];
      if (typeof value === "function")
        localRpcHub.on(key, value);
      else
        Assert.ensureNever(value);
    }
  }
}